const reportEn = {
    auditLog: require('lang/en/report/AuditLog').default,
    inOutLog: require('lang/en/report/InOutLog').default,
    userStatus: require('lang/en/report/UserStatus').default,
};

export default reportEn;